import dynamic from 'next/dynamic';
import { RichTextEntries } from './contentType.constants';

export const RTEmbeddedEntriesMapping: {
  // biome-ignore lint/suspicious/noExplicitAny: dynamic component props vary by rich text entry type
  [key in RichTextEntries]?: React.ComponentType<any>;
} = {
  [RichTextEntries.LeadGenBanner]: dynamic(
    async () => import('../components/RichText/EmbeddedEntries/RTLeadGenBanner'),
  ),
  [RichTextEntries.Button]: dynamic(async () => import('../components/RichText/EmbeddedEntries/RTButton')),
};
